"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiDialog = void 0;
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
var _pixiGame = require("@dragon/pixi-game");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *A more bare version of the dialog less assumptions and froces on.
 */
var PixiDialog = exports.PixiDialog = /*#__PURE__*/function (_PixiGameComponent) {
  /**
   * 
   * @param componentName 
   * @param hStyle 
   * @param pStyle 
   * @param cStyle 
   * @param dialogBgTexture the "frame" asset.
   * @param bgTextureName if there is a cover texture blur or just black gradient, texture needs to be generated before call here.
   */
  function PixiDialog(componentName) {
    var _this;
    var dialogBgTexture = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dialog_frame.png";
    var position = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, PixiDialog);
    _this = _callSuper(this, PixiDialog, [componentName, position]);
    /**
     * The dialog bg, the frame so to say.
     */
    _defineProperty(_this, "_fsDialogBg", void 0);
    _defineProperty(_this, "_contentContainer", void 0);
    _this._contentContainer = new _pixi.Container();
    _this._fsDialogBg = new _pixi.Sprite(_pixi.Texture.from(dialogBgTexture));
    _this._fsDialogBg.scale.set(1);
    _this._fsDialogBg.anchor.set(0.5);

    // prevent "click through" in the dialog.
    _this._fsDialogBg.interactive = true;
    _this._fsDialogBg.on('mousedown', function (e) {
      e.stopPropagation();
    });
    _this._fsDialogBg.on('touchend', function (e) {
      e.stopPropagation();
    });
    _this._contentContainer.addChild(_this._fsDialogBg);
    _this.addChild(_this._contentContainer);
    _this.visible = false;
    _this.alpha = 0;
    return _this;
  }
  _inherits(PixiDialog, _PixiGameComponent);
  return _createClass(PixiDialog, [{
    key: "open",
    value: function open() {
      this.visible = true;
      _gsap["default"].to(this, {
        duration: 0.6,
        alpha: 1
      });
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;
      _gsap["default"].to(this, {
        duration: 0.6,
        alpha: 0,
        onComplete: function onComplete() {
          _this2.visible = false;
        }
      });
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiDialog.js.map